import { render, staticRenderFns } from "./BINavigation.vue?vue&type=template&id=3683ff9a"
import script from "./BINavigation.vue?vue&type=script&lang=js"
export * from "./BINavigation.vue?vue&type=script&lang=js"
import style0 from "./BINavigation.vue?vue&type=style&index=0&id=3683ff9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports